import React from 'react'
import styled from 'styled-components'
import MemberList from '../../components/MemberList'

const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.sectionLightBg};
  padding: 88px 0;
`

const StyledChildren = styled.div`
  margin: 0 0 66px;
  padding: 0 20px;

  ${({ theme }) => theme.media.desktop} {
    padding: 0;
  }
`

const MeetTheTeam = ({ data, children }) => {

  return (
    <StyledWrapper>
      <StyledChildren>{children}</StyledChildren>
      <MemberList data={data} />
    </StyledWrapper>
  )
}

export default MeetTheTeam
